export default __webpack_public_path__ + "static/media/01.357a596f.jpg";